import { ApiAdminRepository } from '../repositories/ApiAdminRepository';
import { ApiBootstrapRepository } from '../repositories/ApiBootstrapRepository';
import { ApiEventsRepository } from '../repositories/ApiEventsRepository';
import { ApiGamesRepository } from '../repositories/ApiGamesRepository';
import { ApiGroupsRepository } from '../repositories/ApiGroupsRepository';
import { ApiGuestAccessRepository } from '../repositories/ApiGuestAccessRepository';
import { ApiMatchingRepository } from '../repositories/ApiMatchingRepository';
import { ApiNotificationRepository } from '../repositories/ApiNotificationRepository';
import { ApiUsersRepository } from '../repositories/ApiUsersRepository';
import { getTelegramInitData } from '../telegram/telegram';

import { AdminService } from './admin/AdminService';
import { BootstrapService } from './bootstrap/BootstrapService';
import { EventsService } from './events/EventsService';
import { GamesService } from './games/GamesService';
import { GroupsService } from './groups/GroupsService';
import { GuestAccessService } from './guestAccess/GuestAccessService';
import { MatchingService } from './matching/MatchingService';
import { NotificationService } from './notifications/NotificationService';
import { UsersService } from './users/UsersService';

export const eventsService = new EventsService(new ApiEventsRepository());
export const groupsService = new GroupsService(new ApiGroupsRepository());
export const usersService = new UsersService(new ApiUsersRepository());
export const guestAccessService = new GuestAccessService(new ApiGuestAccessRepository());
export const gamesService = new GamesService(new ApiGamesRepository());
export const matchingService = new MatchingService(new ApiMatchingRepository());
export const notificationService = new NotificationService(new ApiNotificationRepository());
export const adminService =new AdminService(new ApiAdminRepository());
export const bootstrapService = new BootstrapService(new ApiBootstrapRepository(), { getTelegramInitData });
